import CustomerRightMenu from './customer-right-menu'

export default CustomerRightMenu